import styled from '@emotion/styled';
import { Variables } from '../../base';

export const Wrapper = styled.div`
    position: relative;
    height: 100%;
    width: 12px;
    margin: 0 auto;
`;

export const TimelineDot = styled.div<{ $isFirst?: boolean }>`
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    box-sizing: border-box;
    background: ${({ $isFirst }) =>
        $isFirst ? Variables.ThemeLight.PrimaryConstant6 : Variables.ThemeLight.Background3};
    border: 2px solid
        ${({ $isFirst }) => ($isFirst ? Variables.ThemeLight.PrimaryConstant6 : Variables.ThemeLight.TextXMild)};
`;
